import './global.css';

import { GatsbyBrowser } from "gatsby";

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (typeof document !== 'undefined') {
    // Clear previous page class
    document.body.className = '';

    // Convert path to a safe class name
    const slugClass = location.pathname
      .replace(/\//g, '-')
      .replace(/^-|-$/g, ''); // removes leading/trailing hyphens

    document.body.classList.add(slugClass === 'contact' ? `page-${slugClass}` : 'paper-page');
  }
};
